import { translations } from '@prezly/theme-kit-intl';
import classNames from 'classnames';
import Link from 'next/link';
import { FormattedMessage } from 'react-intl';

import { useThemeSettings } from '@/hooks';
import { IconArrowRight } from 'icons';
import type { StoryWithImage } from 'types';
import { ButtonLink } from 'ui';

import CategoriesList from '../CategoriesList';
import StoryImage from '../StoryImage';
import { StoryPublicationDate } from '../StoryPublicationDate';

import styles from './StoryCard.module.scss';

type Props = {
    story: StoryWithImage;
};

function StoryCard({ story }: Props) {
    const { categories, title, subtitle } = story;
    const { showDate, showSubtitle } = useThemeSettings();

    return (
        <div className={styles.container}>
            <Link href={`/${story.slug}`} locale={false} className={styles.imageWrapper}>
                <StoryImage
                    story={story}
                    size="default"
                    className={styles.image}
                    placeholderClassName={styles.placeholder}
                />
            </Link>
            <div className={styles.content}>
                {categories.length > 0 && (
                    <div className={styles.categories}>
                        <CategoriesList
                            categories={categories}
                            isStatic
                            linkClassName={styles.categoryLink}
                        />
                    </div>
                )}
                <h3
                    className={classNames(styles.title, {
                        [styles.extendedTitle]: !subtitle || !showSubtitle,
                    })}
                >
                    <Link href={`/${story.slug}`} locale={false} className={styles.titleLink}>
                        {title}
                    </Link>
                </h3>

                {subtitle && showSubtitle && <p className={styles.subtitle}>{subtitle}</p>}

                {showDate && (
                    <p className={styles.date}>
                        <StoryPublicationDate story={story} />
                    </p>
                )}

                <ButtonLink
                    className={styles.readMore}
                    href={`/${story.slug}`}
                    icon={IconArrowRight}
                    iconPlacement="right"
                    variation="secondary"
                >
                    <FormattedMessage {...translations.actions.readMore} />
                </ButtonLink>
            </div>
        </div>
    );
}

export default StoryCard;
